import m = require("mithril");
import {Vnode} from "mithril";

/*  helper for writing jQuery based customizations

    usage:

    customization.register('form', '01', ['elementView', ...], function(elementView, ... ){
        return {
            view: elementView({
                content: '<p> initial content </p>',
                init: function(domElement){ ... },   // called when dom element is created
                destroy: function(domElement){ ... },  // called before dom element is removed from dom
                onUpdate: function(domElement){ ... }  // called whenever mithril virtual dom is updated (most of the time this should not be used)
            })
        };
    });
*/

export function elementView(view:any): ()=>Vnode {
    return () => {
        return m("div", {
            oninit: (vnode) => {
               // init is too early, we need oncreate() 👇
            },
            oncreate: (vnode) => {
                if(view.content){
                    vnode.dom.innerHTML = view.content;
                }
                if (view.init) {
                    view.init(vnode.dom);
                }
            },
            onupdate: (vnode) => {
                if(view.onUpdate) {
                    view.onUpdate(vnode.dom);
                }
            },
            onremove: (vnode) => {
                if (view.destroy) {
                    view.destroy(vnode.dom);
                }
            },

        });
    };
}